import { JOURNEY_DETAILS_STEPS } from "src/Modules/Flights/constants";
import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";

export default function WizardBody() {
  const { currentStep } = useStepFlow();
  const { Component } = JOURNEY_DETAILS_STEPS.find((_, index) => index === currentStep)!;
  if (!Component) return null;
  return <Component />;
}
